import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
            <div className="max-w-md">
              <div className="flex items-center gap-2 mb-3">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-file-list-3-line text-base" />
                </span>
                <span className="font-heading font-bold text-foreground-900">{t('brand')}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t('footer.disclaimer')}</p>
            </div>

            <div className="flex flex-col gap-2">
              <h4 className="font-heading font-semibold text-foreground-900 text-sm">
                <Link to="/" className="hover:text-primary-700 transition-colors">{t('footer.about')}</Link>
              </h4>
              <Link to="/#categories" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap">
                {t('nav.categories')}
              </Link>
              <Link to="/usfans-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap">
                {t('nav.guides')}
              </Link>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-6 border-t border-background-200">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} {t('brand')}. {t('footer.rights')}
            </p>
            <p className="text-xs text-foreground-500">USFans Spreadsheet · QC · Shipping · Reviews</p>
          </div>
        </div>
      </div>
    </footer>
  );
}